module.exports = __webpack_public_path__ + "images/ty-downloadable-auth-user-mobile.jpg";